import {Component, OnInit} from '@angular/core';
import {Router} from "@angular/router";
import {UsefulFunctionsService} from "./useful-functions.service";


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit{

  constructor(public usefulFunctionsService: UsefulFunctionsService) {}

  ngOnInit(): void {
  }



}
